module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f644.8210e7f5.svg";